import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopicMemberLabelLinkContainerModel, NotificationLabelTopicLinkResourceContainer, NotificationProcessorType } from '../../../../../../models';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({ providedIn: 'root' })

export class TopicMemberLabelLinkService extends BaseApiTemplateService<TopicMemberLabelLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'notification/label-topic-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'notification/label-topic-links';
    this.httpClient = http;
  }

  topicUnAssignment(topicMemberLabelLinkContainerModel: TopicMemberLabelLinkContainerModel, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/configure-unassignment/backoffice-ep'
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/configure-unassignment/backoffice-ep';
    }
    
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      topicMemberLabelLinkContainerModel,
      this.getHttpHeader(apiVisa)
    );
  }

  topicAssignment(topicMemberLabelLinkContainerModel: TopicMemberLabelLinkContainerModel, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/configure-assignment/backoffice-ep'
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/configure-assignment/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      topicMemberLabelLinkContainerModel,
      this.getHttpHeader(apiVisa)
    );
  }

  updateAssignment(notificationLabelTopicLinkResourceContainer: NotificationLabelTopicLinkResourceContainer, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/update-active-processors/backoffice-ep'
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/update-active-processors/backoffice-ep';
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      notificationLabelTopicLinkResourceContainer,
      this.getHttpHeader(apiVisa)
    );
  }

  getGenericResourceByAssignmentType(notificationProcessorType: NotificationProcessorType, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/active-processors/backoffice-ep' + notificationProcessorType;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path + '/active-processors/backoffice-ep' + `?notificationProcessorType=${notificationProcessorType}`;
    }
    
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code,
        'Content-Type': 'application/json'
      })
    };

    return this.httpClient.get<ApiResponseModel<NotificationLabelTopicLinkResourceContainer>>(
      url,
      httpOptions
    );
  }
}
